import request from './request';

export interface PricePoint {
  id: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  productCode: string;
  simulationId: number;
  timePoint: string;
  price: number;
  relativeOffset: number;
  sequenceNumber: number;
  isActive: boolean;
}

export interface SimulationParams {
  productCode: string;
  finalPrice: number;
  peakTimeSeconds: number;
  peakDurationSeconds: number;
  totalDurationSeconds: number;
  amplitudeFactor: number;
}

export interface SimulationResult {
  id: number;
  productCode: string;
  startPrice: number;
  finalPrice: number;
  peakTimeSeconds: number;
  peakDurationSeconds: number;
  totalDurationSeconds: number;
  amplitudeFactor: number;
  isActive: boolean;
  startTime: string;
  endTime: string;
  userId: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * 价格模拟记录及关联点数据统计
 */
export interface PriceSimulationWithPointCount {
  priceSimulation: SimulationResult;
  pointCount: number;
}

/**
 * 获取价格模拟预览
 * @param params 模拟参数
 */
export const previewSimulation = (params: SimulationParams): Promise<PricePoint[]> => {
  return request.post('/market/api/v1/admin/market/simulation/preview', params);
};

/**
 * 执行价格模拟
 * @param params 模拟参数
 */
export const executeSimulation = (params: SimulationParams): Promise<SimulationResult> => {
  return request.post('/market/api/v1/admin/market/simulation', params);
};

/**
 * 删除价格模拟记录
 * @param id 价格模拟ID
 */
export const deleteSimulation = (id: number): Promise<string> => {
  return request.delete(`/market/api/v1/admin/market/simulation/${id}`);
};

/**
 * 取消价格模拟（通过产品代码）
 * @param productCode 产品代码
 */
export const cancelSimulation = (productCode: string): Promise<string> => {
  return request.delete(`/market/api/v1/admin/market/simulation/${productCode}`);
};

/**
 * 获取当前激活的价格模拟
 */
export const fetchActiveSimulations = (): Promise<SimulationResult[]> => {
  return request.get('/market/api/v1/admin/market/simulation');
};

/**
 * 获取所有价格模拟记录（包括历史）
 */
export const fetchAllSimulations = (): Promise<PriceSimulationWithPointCount[]> => {
  return request.get('/market/api/v1/admin/market/simulation/all');
};

/**
 * 取消价格模拟激活状态（保留数据）
 * @param productCode 产品代码
 */
export const deactivateSimulation = (productCode: string): Promise<string> => {
  return request.put(`/market/api/v1/admin/market/simulation/${productCode}/deactivate`);
};

/**
 * 清空价格模拟关联的点数据
 * @param simulationId 价格模拟ID
 */
export const clearSimulationPoints = (simulationId: number): Promise<string> => {
  return request.delete(`/market/api/v1/admin/market/simulation/${simulationId}/points`);
};